import { Button, Grid, MenuItem, Paper, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import FromType from "../../../partials/fromType";
import InputFormat from "../../../partials/inputForm";
import { genders } from "../../../utils/setting";
import CountryCode from "../../countryCode";
import Loading from "../../loading";
import Snackbar from "../../snackbar";
import InputAddress from "../../suggestAddress";
import { edit as styles } from "./styles";

class EditForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contact: {
        city: "",
        address: "",
        country: "",
        state: "",
        district: "",
        ...this.props.contact,
      },
    };
  }
  componentDidMount = () => {
    this.setState({
      contact: {
        city: "",
        address: "",
        country: "",
        state: "",
        district: "",
        ...this.props.contact,
      },
    });
  };
  componentWillReceiveProps(nextProps) {
    if (nextProps.contact !== this.props.contact) {
      this.setState({
        contact: {
          city: "",
          address: "",
          country: "",
          state: "",
          district: "",
          ...nextProps.contact,
        },
      });
    }
  }
  handelSubmit = async () => {
    const { contact } = this.state;
    const { t } = this.props;
    this.loading.startLoading();
    let check = await this.props.update({
      snackbar: this.snackbar,
      contact: contact,
      t: t,
    });
    if (check && check.code) {
      this.setState({
        contact: {
          city: "",
          address: "",
          country: "",
          state: "",
          district: "",
          ...check.data,
        },
      });
      this.props.handleClose();
      await this.props.getList();
    }
    this.loading.stopLoading();
  };

  snackbar = (mess, type) => {
    this.mSnackbar.handleClick(mess, type);
  };
  handleChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let { contact } = this.state;
    contact[name] = value;
    this.setState({ contact: contact });
  };
  handleChangeExtra = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    let { contact } = this.state;
    contact.extraData[name] = value;
    this.setState({ contact: contact });
  };

  handleChangeAddress = (value) => {
    let { contact } = this.state;
    contact.longtitude = value.lng;
    contact.latitude = value.lat;
    delete value.lat;
    delete value.lng;
    contact = { ...contact, ...value };
    this.setState({ contact });
  };
  handleCountryCode = (name, value) => {
    let { contact } = this.state;
    contact[name] = value;
    this.setState({ contact });
  };

  render() {
    const { classes, handleClose, t } = this.props;
    let { contact } = this.state;
    if (contact.extraData && typeof contact.extraData === "string") {
      try {
        contact.extraData = JSON.parse(contact.extraData);
      } catch (err) {
        console.log("err");
      }
    }
    return (
      <Paper square={true} className={classes.editFormContainer}>
        {/* <Dialog
                    onRef={dialog => (this.mDialog = dialog)}
                    disagree={t("customer_listcustomer_editcustomer_cancel")}
                    agree={t("customer_listcustomer_editcustomer_continute")}
                    title={t("customer_listcustomer_editcustomer_confirm")}
                    content={t("customer_listcustomer_editcustomer_are_you_sure_that_you_want_to_edit_customer_information")}
                    action={this.handleSubmit}
                /> */}
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />

        <Grid container spacing={3} alignItems="flex-end">
          <Grid item xs={12} sm={6}>
            <Grid container spacing={3} alignItems="flex-end">
              <Grid item xs={6} sm={3}>
                <CountryCode
                  margin="normal"
                  code={contact.countryCode}
                  handleCountryCode={this.handleCountryCode}
                />
              </Grid>
              <Grid item xs={6} sm={9}>
                <InputFormat
                  required
                  label={t("contact_phone")}
                  name="phone"
                  margin="normal"
                  fullWidth
                  value={contact.phone}
                  onChange={this.handleChange}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={6}>
            <InputFormat
              required
              label={t("contact_name")}
              name="name"
              margin="normal"
              fullWidth
              value={contact.name}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputFormat
              required
              label={t("contact_email")}
              name="email"
              margin="normal"
              fullWidth
              value={contact.email}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputFormat
              // required
              label={t("contact_age")}
              name="age"
              margin="normal"
              fullWidth
              value={contact.age}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputFormat
              select
              // required
              label={t("contact_gender")}
              name="gender"
              margin="normal"
              fullWidth
              value={contact.gender}
              onChange={this.handleChange}
            >
              {genders.map((gender, index) => (
                <MenuItem key={index} value={gender.value}>
                  {t(gender.label)}
                </MenuItem>
              ))}
            </InputFormat>
          </Grid>

          <Grid item xs={12} sm={4}>
            <InputFormat
              label={t("contact_socialId")}
              name="socialId"
              margin="normal"
              fullWidth
              value={contact.socialId}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={8}>
            <InputFormat
              label={t("contact_socialLink")}
              name="socialLink"
              margin="normal"
              fullWidth
              value={contact.socialLink}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputFormat
              label={t("contact_ip")}
              name="ip"
              margin="normal"
              fullWidth
              value={contact.ip}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FromType
              label={t("contact_fromType")}
              name="fromType"
              margin="normal"
              fullWidth
              value={contact.fromType}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <InputFormat
              label={t("contact_category")}
              name="category"
              margin="normal"
              fullWidth
              disabled
              value={contact.category}
              onChange={this.handleChange}
              InputProps={{
                classes: {
                  input: classes.textCapitalize,
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <InputFormat
              disabled
              multiline
              rowsMax={3}
              label={t("contact_categoryId")}
              name="categoryId"
              margin="normal"
              fullWidth
              value={
                contact.categoryId && contact.categoryId.length
                  ? contact.categoryId
                    .map((e) => e.title || e.name || e.id)
                    .join(", ")
                  : contact.categoryId
              }
              onChange={this.handleChange}
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <InputFormat
              disabled
              label={t("contact_userAgent")}
              name="userAgent"
              margin="normal"
              fullWidth
              value={contact.userAgent}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <InputAddress
              multiline
              name="address"
              label={t("contact_address")}
              margin="normal"
              value={contact.address}
              handleChange={this.handleChangeAddress}
              required
              InputProps={{
                classes: {
                  input: classes.inputMultiline,
                },
              }}
            />
          </Grid>

          <Grid item xs={12} sm={12}>
            <Grid container spacing={3}>
              <Grid item xs={6} sm={3}>
                <InputFormat
                  // required
                  label={t("contact_country")}
                  name="country"
                  margin="normal"
                  fullWidth
                  value={contact.country}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <InputFormat
                  // required
                  label={t("contact_state")}
                  name="state"
                  margin="normal"
                  fullWidth
                  value={contact.state}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <InputFormat
                  // required
                  label={t("contact_city")}
                  name="city"
                  margin="normal"
                  fullWidth
                  value={contact.city}
                  onChange={this.handleChange}
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <InputFormat
                  // required
                  label={t("contact_district")}
                  name="district"
                  margin="normal"
                  fullWidth
                  value={contact.district}
                  onChange={this.handleChange}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12}>
            <InputFormat
              required
              label={t("contact_content")}
              name="content"
              margin="normal"
              fullWidth
              multiline
              rows="2"
              value={contact.content}
              onChange={this.handleChange}
            />
          </Grid>

          {contact.extraData && (
            <Grid item xs={12} sm={12}>
              <Typography variant="subtitle2">
                {t("contact_extraData")}
              </Typography>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                  {contact.extraData &&
                    Object.keys(contact.extraData).map((e) => {
                      return (
                        <InputFormat
                          required
                          // disabled
                          label={e}
                          name={e}
                          margin="normal"
                          fullWidth
                          value={contact.extraData[e]}
                          onChange={this.handleChangeExtra}
                        />
                      );
                    })}
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
        <div className={classes.backgroundButton}>
          <Button variant="contained" color="secondary" onClick={handleClose}>
            {t("contact_cancel")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            style={{ marginLeft: 8 }}
            onClick={this.handelSubmit}
          >
            {t("contact_update")}
          </Button>
        </div>
      </Paper>
    );
  }
}

EditForm.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  one_contact: state.serviceContacts.one_contact,
});

const mapDispatch = (dispatch) => ({
  update: dispatch.serviceContacts.update,
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(EditForm)));
